function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23037",
    transform: "translate(-450.51 -191.727)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 679",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(450.51 191.727)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.59 15.207v5.958a3.212 3.212 0 0 1-3.633 3.635h-3.234a.363.363 0 0 1-.363-.363v-3.729a2.527 2.527 0 0 0-2.008-2.535 2.428 2.428 0 0 0-2.836 2.387v3.875a.363.363 0 0 1-.363.363H7.847a3.212 3.212 0 0 1-3.633-3.633v-5.958a5.364 5.364 0 0 0 2.3.509 6.062 6.062 0 0 0 3.718-1.284 5.9 5.9 0 0 0 7.351 0 6.062 6.062 0 0 0 3.717 1.284 5.349 5.349 0 0 0 2.289-.509zM8.452 3c-3.028 0-3.491.993-3.99 2.468L3.2 9.19a3.541 3.541 0 0 0 1.453 4.216 3.7 3.7 0 0 0 1.859.494 3.973 3.973 0 0 0 3.7-2.422 4.018 4.018 0 0 0 7.375 0 3.973 3.973 0 0 0 3.7 2.422 3.7 3.7 0 0 0 1.86-.494A3.541 3.541 0 0 0 24.6 9.19l-1.252-3.722c-.5-1.475-.969-2.468-4-2.468z",
    transform: "translate(461.874 202.49)",
    style: {
      fill: "#8dcea3"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellers);
export default __webpack_public_path__ + "static/media/sellers.8395706ae89519ed32c60278c826612b.svg";
export { ForwardRef as ReactComponent };